<template>
  <BaseModal
    :value="true"
    @input="$emit('close')"
    title="Edit Application Notes"
  >
    <div class="notes-modal-content">
      <h3 class="text-lg font-semibold mb-4">
        {{ application.make }} {{ application.model }} {{ application.year }}
      </h3>
      <textarea
        v-model="notes"
        rows="6"
        class="regular full bordered"
        placeholder="Enter notes for this application..."
      ></textarea>
      <div class="modal-actions">
        <button @click="save" class="btn-success-button">Save Notes</button>
        <button @click="$emit('close')" class="btn-dark-button">Cancel</button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
export default {
  name: "NotesModal",
  props: {
    application: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      notes: this.application.notes || ""
    };
  },
  methods: {
    save() {
      this.$emit("save", this.notes);
    }
  }
};
</script>

<style lang="scss" scoped>
.notes-modal-content {
  padding: 1rem;
}

.modal-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>
